import {EventObj} from "./CreatEventFromEventBrite";
import React, {useContext, useState} from "react";
import {Button} from "@material-ui/core";
import moment from "moment";
import {AppContext} from "../../AppContext";
import {MessageContext} from "../../MessageContext";
import {EventBriteFetcher} from "../EventBriteHelper";
import {useHistory} from "react-router-dom";

interface Props {
    ebEvent: EventObj
}

function showPeopleCounts(venueType: string, selectPackageType: (packageType: string) => void) {
    return <>
        {venueType === "PartyVenue" ?
            <>
                <div>
                    <h2>30</h2>
                    <ul>
                        <li>30 Max Attendees</li>
                        <li>2 Hour cutoff time</li>
                        <li>$0</li>
                        <li>This is the trial tier. You can upgrade at any time, even after the event has started.</li>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectPackageType("Trial")}
                        >
                            Select
                        </Button>
                    </ul>
                </div>
                <div>
                    <h2>50</h2>
                    <ul>
                        <li>50 Max Attendees</li>
                        <li>Full event time</li>
                        <li>$18/hour (8 hour day)</li>
                        <li>Up to 100 attendees. A full day is capped at 8 hours. Your event can continue, but
                            you won't be billed more for that day.
                        </li>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectPackageType("50")}
                        >
                            Select
                        </Button>
                    </ul>
                </div>
                <div>
                    <h2>100</h2>
                    <ul>
                        <li>100 Max Attendees</li>
                        <li>Full event time</li>
                        <li>$29/hour (8 hour day)</li>
                        <li>Up to 100 attendees. A full day is capped at 8 hours. Your event can continue, but
                            you won't be billed more for that day.
                        </li>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectPackageType("100")}
                        >
                            Select
                        </Button>
                    </ul>
                </div>
            </>
            :
            <>
                <div>
                    <h2>100</h2>
                    <ul>
                        <li>100 Max Attendees</li>
                        <li>Full event time</li>
                        <li>$35/hour (8 hour day)</li>
                        <li>Up to 100 attendees. A full day is capped at 8 hours. Your event can continue, but
                            you won't be billed more for that day.
                        </li>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectPackageType("100")}
                        >
                            Select
                        </Button>
                    </ul>
                </div>
                <div>
                    <h2>250</h2>
                    <ul>
                        <li>100 Max Attendees</li>
                        <li>Full event time</li>
                        <li>$75/hour (8 hour day)</li>
                        <li>Up to 250 attendees. A full day is capped at 8 hours. Your event can continue, but
                            you won't be billed more for that day.
                        </li>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectPackageType("250")}
                        >
                            Select
                        </Button>
                    </ul>
                </div>
                <div>
                    <h2>500</h2>
                    <ul>
                        <li>100 Max Attendees</li>
                        <li>Full event time</li>
                        <li>$125/hour (8 hour day)</li>
                        <li>Up to 500 attendees. A full day is capped at 8 hours. Your event can continue, but
                            you won't be billed more for that day.
                        </li>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectPackageType("500")}
                        >
                            Select
                        </Button>
                    </ul>
                </div>
                <div>
                    <h2>1000</h2>
                    <ul>
                        <li>100 Max Attendees</li>
                        <li>Full event time</li>
                        <li>$225/hour (8 hour day)</li>
                        <li>Up to 1000 attendees. A full day is capped at 8 hours. Your event can continue, but
                            you won't be billed more for that day.
                        </li>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => selectPackageType("1000")}
                        >
                            Select
                        </Button>
                    </ul>
                </div>
            </>
        }
    </>

}

export default function CreateEventVenueSelection(props: Props) {
    const ebFetcher = new EventBriteFetcher()
    const [venueType, setVenueType] = useState<string | null>(null)
    const [processing, setProcessing] = useState(false)

    const history = useHistory()

    const context = useContext(AppContext)
    const messageContext = useContext(MessageContext)
    const createEvent = (packageType: string) => {
        setProcessing(true)
        creatFromEventBrite(props.ebEvent)
    }

    const creatFromEventBrite = (ebEvent: EventObj) => {
        ebFetcher.fetch(`https://www.eventbriteapi.com/v3/organizations/${ebEvent.organization_id}/webhooks/`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                    endpoint_url: "https://conf-game.herokuapp.com/process-webhook",
                    actions: "order.placed,order.updated,attendee.updated,event.updated",
                    event_id: ebEvent.id
                }
            )
        })
            .then(response => response.json())
            .then(json => creatFromEventBriteWithWebhook(ebEvent, json.id))
    }

    const creatFromEventBriteWithWebhook = (ebEvent: EventObj, webhookId: string) => {
        const startDate = moment(ebEvent.start).toDate()
        const endDate = moment(ebEvent.end).toDate()

        fetch(`${process.env.REACT_APP_API_CALL}/events`, {
            method: "POST",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                name: ebEvent.name,
                description: ebEvent.description,
                host_user: (context.currentUser as any).id,
                price: 0,
                start_time: startDate,
                finish_time: endDate,
                timezone: ebEvent.timeZone,
                venue: venueType,
                venueData: "{}",
                eventbrite_id: ebEvent.id,
                eventbrite_webhook_id: webhookId
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.errors) {
                    messageContext.showErrorMessage(response.errors)
                } else {
                    messageContext.showSuccessMessage("Event has been created")
                    history.push(`/admin/event/${response.id}`)
                }
            })
    }

    const displayBlock = () => {
        return <>
            {venueType ?
                showPeopleCounts(venueType, createEvent)
                :
                <>
                    <div>
                        <h2>Party</h2>
                        <ul>
                            <li>One main video stream</li>
                            <li>Blah blah</li>
                            <li>Starts at $0!</li>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setVenueType("PartyVenue")}
                            >
                                Select
                            </Button>
                        </ul>
                    </div>
                    <div>
                        <h2>Conference</h2>
                        <ul>
                            <li>Main video stream, 4 track streams</li>
                            <li>Blah blah</li>
                            <li>Starts at $49</li>
                        </ul>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => setVenueType("MainVenue")}
                        >
                            Select
                        </Button>
                    </div>
                </>
            }
        </>
    }
    return <div className="venue-list">
        {processing ?
            <div>Creating event</div>
            :
            displayBlock()
        }

    </div>
}
